import { useRef } from "react";
import { useLocation } from "react-router-dom";

export const useSearchParams = () => {
    const paramsRef = useRef(new URLSearchParams(useLocation().search))
    return paramsRef.current;
};